<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="classId" label="班级名称">
<!--          <a-input placeholder="请输入班级id" v-model="model.classId" />-->
          <j-dict-select-tag v-model="model.classId" dictCode="school_class,name,id,delete_flag=0" placeholder = '请选择班级名称'/>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="content" label="活动内容">
<!--          <a-input placeholder="请输入活动内容" v-model="model.content" />-->
          <a-textarea v-model="model.content" rows="4" placeholder='请输入活动内容'/>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="picUrl" label="活动图片">
<!--          <a-input placeholder="请输入活动图片地址" v-model="model.picUrl" />-->
          <j-image-upload text="上传活动图片" v-model="model.picUrl" :isMultiple="true"></j-image-upload>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="videoUrl" label="视频链接">
          <j-upload  v-model="model.videoUrl" placeholder="请输入样例文本内容"></j-upload>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="visible" label="是否给家长可见">
<!--          <a-input-number v-model="model.visible"/>-->
          <j-dict-select-tag v-model="model.visible" dictCode="visible_status" />
        </a-form-model-item>
<!--        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishStatus" label="发布状态">-->
<!--&lt;!&ndash;          <a-input-number v-model="model.publishStatus"/>&ndash;&gt;-->
<!--          <j-dict-select-tag v-model="model.publishStatus" dictCode="publish_status"/>-->
<!--        </a-form-model-item>-->

      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import moment from "moment"
  import JDictSelectTag from '@/components/dict/JDictSelectTag'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JUpload from '@/components/jeecg/JUpload'
  export default {
    name: "SchoolActivityModal",
    components:{
      JImageUpload,
      JDictSelectTag,
      JUpload,
  },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules:{
        },
        url: {
          add: "/aigoes/schoolActivity/add",
          edit: "/aigoes/schoolActivity/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        //初始化默认值
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.form.clearValidate();
      },
      handleOk () {
        const that = this;
        // 触发表单验证
         this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
             return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },


    }
  }
</script>

<style lang="less" scoped>

</style>